import { render, staticRenderFns } from "./ComposerIndex.vue?vue&type=template&id=6208e3b7&scoped=true&"
import script from "./ComposerIndex.vue?vue&type=script&lang=js&"
export * from "./ComposerIndex.vue?vue&type=script&lang=js&"
import style0 from "./ComposerIndex.vue?vue&type=style&index=0&id=6208e3b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208e3b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6208e3b7')) {
      api.createRecord('6208e3b7', component.options)
    } else {
      api.reload('6208e3b7', component.options)
    }
    module.hot.accept("./ComposerIndex.vue?vue&type=template&id=6208e3b7&scoped=true&", function () {
      api.rerender('6208e3b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/ComposerIndex.vue"
export default component.exports